import { Card } from "@devhop/ui";
import type { ChecklistResultStatsResult } from "@/modules/checklist/domain/types/result";
import { formatDateTimeLocal } from "@/shared/lib/date-time";

type ChecklistResultRecentPartialProps = {
  stats: ChecklistResultStatsResult;
  onExecutionClick: (executionId: string) => void;
};

export function ChecklistResultRecentPartial({
  stats,
  onExecutionClick,
}: ChecklistResultRecentPartialProps) {
  if (stats.recentPartialCompletions.length === 0) return null;

  return (
    <Card className="gap-0 p-6">
      <h2 className="mb-4 font-semibold text-lg">
        ບັນທຶກທີ່ປິດແລ້ວແຕ່ຍັງມີລາຍການບໍ່ຄົບ (20 ລ່າສຸດ)
      </h2>
      <div className="space-y-2">
        {stats.recentPartialCompletions.map((row) => (
          <button
            key={row.id}
            type="button"
            className="flex w-full cursor-pointer items-center justify-between rounded-lg border p-3 text-left transition-colors hover:bg-muted/50"
            onClick={() => onExecutionClick(row.id)}
          >
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <span className="font-medium">{row.checklistTitle}</span>
                {row.departmentName && (
                  <span className="text-muted-foreground text-sm">
                    ({row.departmentName})
                  </span>
                )}
              </div>
              <div className="mt-1 text-muted-foreground text-sm">
                {row.completedAt || row.startedAt
                  ? formatDateTimeLocal(
                      String(row.completedAt ?? row.startedAt),
                    ).slice(0, 16)
                  : "-"}
              </div>
            </div>
            <span className="shrink-0 text-primary text-sm">ເບິ່ງລາຍລະອຽດ →</span>
          </button>
        ))}
      </div>
    </Card>
  );
}
